
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainButton from "../../../common/buttons/MainButton";
import Link from "next/link";
import { numberWithCommas, numberWithCommasNull } from "../../../../helpers/numberWithCommas";
function validatePositiveNumber(input) {
    const regex = /^\d+(\.\d+)?$/;
    return regex.test(input);
}
const Banner = ({ t, apiData }) => {
    const banner = t('home:banner', {}, { returnObjects: true });
    const [ethAmount, setEthAmount] = useState('');
    const [pepdAmount, setPepdAmount] = useState('');
    useEffect(() => {
        if (apiData && ethAmount) {
            setPepdAmount(numberWithCommas((+ethAmount * +apiData?.eth_price) / +apiData?.current_token_price));
        }
        else {
            setPepdAmount('');
        }
    }, [ethAmount, apiData]);
    return (<section className={'banner'}>
            <picture>
                <source media="(max-width: 768px)" srcSet={`/img/pages/home/banner/banner_money_small.webp?v=3`} type="image/webp"/>
                <source media="(min-width: 769px)" srcSet={`/img/pages/home/banner/banner_money.webp?v=3`} type="image/webp"/>
                <source media="(max-width: 768px)" srcSet={`/img/pages/home/banner/banner_money_small.png?v=3`}/>
                <source media="(min-width: 769px)" srcSet={`/img/pages/home/banner/banner_money.png?v=3`}/>
                <img src={`/img/pages/home/banner/banner_money.png?v=2`} alt={`PEPE Dollar`} width={1441} height={716} className='money_img'/>
            </picture>
            <div className="container">
                <div className="banner_wrapper">
                    <div className={'banner_title'}>
                        <h1 className={'banner_title_title'}>
                            <div><span>Pepe</span><span className={'black'}>Dollar</span></div>
                            <span>{banner.title_2}</span>
                            <span>{banner.title_3}</span>
                            <span>{banner.title_4}</span>
                        </h1>
                        <div className={'banner_title_cta'}>
                            <Link className='buy_cta' prefetch={false} href={process.env.NEXT_PUBLIC_APP_URL}>
                                <MainButton text={banner.buy_cta}/>
                            </Link>
                            <Link className='tg_cta' prefetch={false} href={"https://t.me/pepedollarcommunity"}>
                                <MainButton text={banner.tg_cta}/>
                            </Link>
                        </div>
                    </div>
                    <div className={'banner_form'}>
                        <div className={'banner_socials'}>
                            <Link aria-label={'telegram'} className='banner_socials_link' prefetch={false} href={'https://t.me/pepedollarcommunity'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68693 7.68696 0.000858621 11.7565 0 16C0 20.2417 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2417 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z" fill="url(#paint0_linear_1478_1201)"/>
                                    <path d="M7.2425 15.831C11.9075 13.799 15.0175 12.4593 16.5725 11.812C21.0175 9.96374 21.94 9.64274 22.5425 9.63187C22.675 9.62974 22.97 9.66249 23.1625 9.81812C23.3225 9.94937 23.3675 10.1269 23.39 10.2515C23.41 10.376 23.4375 10.6597 23.415 10.8812C23.175 13.4112 22.1325 19.5507 21.6025 22.3845C21.38 23.5835 20.9375 23.9855 20.51 24.0247C19.58 24.1102 18.875 23.4107 17.975 22.821C16.5675 21.8977 15.7725 21.3232 14.405 20.4225C12.825 19.3815 13.85 18.8092 14.75 17.8742C14.985 17.6295 19.08 13.9057 19.1575 13.568C19.1675 13.5257 19.1775 13.3682 19.0825 13.2852C18.99 13.202 18.8525 13.2305 18.7525 13.253C18.61 13.285 16.3625 14.772 12.0025 17.7137C11.365 18.1522 10.7875 18.366 10.2675 18.3547C9.6975 18.3425 8.5975 18.0317 7.78 17.7662C6.78 17.4405 5.9825 17.2682 6.0525 16.715C6.0875 16.427 6.485 16.1322 7.2425 15.831Z" fill="white"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_1478_1201" x1="1600" y1="0" x2="1600" y2="3200" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#2AABEE"/>
                                            <stop offset="1" stopColor="#229ED9"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </Link>
                            <Link aria-label={'twitter'} className='banner_socials_link' prefetch={false} href={"https://x.com/PepeDollarETH"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M8.5 23.5L14.791 17.2105M14.791 17.2105L8.5 8.5H12.6655L17.2105 14.791L23.5 8.5M14.791 17.2105L19.333 23.5H23.5L17.209 14.7895" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M31 16C31 24.2845 24.2845 31 16 31C7.7155 31 1 24.2845 1 16C1 7.7155 7.7155 1 16 1C24.2845 1 31 7.7155 31 16Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                        </div>
                        <div className="banner_form_wrapper">
                            <h2 className={'form_main_title'}><span style={{ color: "#BED992" }}>Pepe Dollar</span> {banner.presale}</h2>
                            <h3 className={'form_stage_title'}>{banner.stage} <span style={{ color: "#E0EFBB" }}>{apiData?.stage_name?.split(' ')[1]}</span></h3>
                            <p className={'form_values'}>1 $PEPD = ${+apiData?.current_token_price || '0.00'}</p>
                            <p className={'form_values margin'}>{banner.launch_price} = $0.03695</p>
                            <div className="progress_bar" style={{
            "--prog": apiData?.percent_tokens > 5 ? `calc(${apiData?.percent_tokens}% - 8px)` : `${apiData?.percent_tokens}%`,
            "--br": apiData?.percent_tokens > 5 ? '8px' : '0px'
        }}>
                                <div className="pct_sold">
                                    <div style={{
            color: apiData?.percent_tokens > 15 ? '#fff' : '#000',
            left: `${apiData?.percent_tokens > 15 ? `calc(${apiData?.percent_tokens}% - 42px)` : '10px'}`
        }} className="pct_sold_value">{Number(apiData?.percent_tokens).toFixed(0)}<span className={'pct'}>%</span></div>
                                </div>
                            </div>
                            <p className={'form_stats'}>{banner.usd_raised} <span style={{
            color: "#BED992",
            whiteSpace: 'nowrap'
        }}>{numberWithCommasNull(Number(apiData?.usd_raised_by_stage).toFixed(0))}/{numberWithCommasNull(Number(apiData?.total_usd_by_stage).toFixed(0))}</span>
                            </p>
                            <p className={'form_stats margin'}>{banner.token_sold} <span style={{
            color: "#BED992",
            whiteSpace: 'nowrap'
        }}>{numberWithCommasNull(Number(apiData?.tokens_sold_by_stage).toFixed(2))}/{numberWithCommasNull(Number(apiData?.total_tokens_by_stage).toFixed(2))}</span>
                            </p>
                            <picture>
                                <source srcSet={`/img/pages/home/banner/methods.webp`} type="image/webp"/>
                                <source srcSet={`/img/pages/home/banner/methods.png`}/>
                                <img src={`/img/pages/home/banner/methods.png`} alt={`PEPE Dollar Presale`} width={554} height={84} className='form_methods'/>
                            </picture>
                            <div className={'input_wrapper'}>
                                <label htmlFor={'eth_amount'}>{banner.input_eth_1}<span className={'f_b'}>ETH</span>{banner.input_eth_2}
                                </label>
                                <input id={'eth_amount'} disabled={!apiData.eth_price} value={ethAmount} onChange={(e) => {
            if (!validatePositiveNumber(e.target.value)) {
                e.target.value = e.target.value.replace(/[^\d.]/g, "");
                setEthAmount(e.target.value);
            }
            setEthAmount(e.target.value);
        }}/>
                                <img width={44} height={44} src={'/img/pages/home/banner/eth_circle.png'} alt={'buy PEPD'}/>
                            </div>
                            <div className={'input_wrapper'}>
                                <label htmlFor={'pepd_amount'}>{banner.input_pepd_1}<span className={'f_b'}>PEPD</span>{banner.input_pepd_2}
                                </label>
                                <input id={'pepd_amount'} readOnly value={pepdAmount}/>
                                <img width={180} height={180} src={'/img/pages/home/banner/logo.png'} alt={'buy PEPD'}/>
                            </div>
                            <Link className='connect_cta' prefetch={false} href={process.env.NEXT_PUBLIC_APP_URL}>
                                <MainButton text={banner.connect_cta}/>
                            </Link>
                            <div className={'form_cta_list'}>
                                <Link className='other_cta' prefetch={false} scroll={false} href={"/#how-to-buy"}>
                                    <MainButton text={banner.how_to_cta}/>
                                </Link>
                                <Link className='other_cta' prefetch={false} target={'_blank'} href={"https://x.com/PepeDollarETH"}>
                                    <MainButton text={banner.giveaway}/>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className={'banner_audit'}>
                        <p>{banner.audit}</p>
                        <picture>
                            <source srcSet={`/img/pages/home/banner/coinsult.webp`} type="image/webp"/>
                            <source srcSet={`/img/pages/home/banner/coinsult.png`}/>
                            <img src={`/img/pages/home/banner/coinsult.png`} alt={`PEPE Dollar Presale`} width={98} height={98}/>
                        </picture>
                    </div>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__1989dd5007d__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd5007d__ as getStaticProps }
  